<template>
  <div class="user-management">
    <div class="page-title">{{ $t("lang.title_user") }}</div>
    <ATable
      ref="table"
      max-height="750px"
      :data="items"
      :loading="loading"
      :search_field="search_field"
      :placeholder="placeholder"
      :disable_insert="!has_grant_write"
      hide-pagination
      border
      @row-click="handleClickRow"
      @clicked-create="handleClickedCreate"
    >
      <el-table-column
        type="index"
        :label="$t('lang.No')"
        :width="$width.index"
        :index="handleIndex"
      ></el-table-column>
      <el-table-column prop="account" :label="$t('lang.user_id')" width="120"></el-table-column>
      <el-table-column prop="name" :label="$t('lang.user_name')" width="120"></el-table-column>
      <el-table-column prop="tel" :label="$t('lang.user_tel')" width="120"></el-table-column>
      <el-table-column 
        prop="branch_name" 
        width="100"
        label="부서" 
      />
      <el-table-column 
        prop="user_group_name" 
        width="100"
        :label="$t('lang.user_group')" 
      />
      <el-table-column
        prop="last_login_at"
        :label="$t('lang.last_login')"
        :formatter="util.dateTimeFormat"
        :width="$width.datetime"
      ></el-table-column>
      <el-table-column prop="desc" :label="$t('lang.notes')"></el-table-column>
      <el-table-column
        prop="created_user_name"
        :label="$t('lang.created_user_name')"
        :width="$width.username"
      />
      <el-table-column
        prop="modified_user_name"
        :label="$t('lang.modified_user_name')"
        :width="$width.username"
      />
      <el-table-column
        prop="created_at"
        :label="$t('lang.created_at')"
        :width="$width.date"
        :formatter="util.dateFormat"
      />
      <el-table-column
        prop="modified_at"
        :label="$t('lang.modified_at')"
        :width="$width.date"
        :formatter="util.dateFormat"
      />
    </ATable>
    <el-dialog
      ref="dialog"
      top="0"
      width="600px"
      class="userform-dialog"
      destroyOnClose
      :title="$t('lang.title_user')"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      @opened="handleOpened"
    >
      <UserForm 
        ref="form" 
        :data="form_data" 
        :has_grant_write="has_grant_write" 
        @completed="handleCompleted" 
      />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { form_container } from "@/common/mixins/form_container";
import { authority_level } from "@/common/mixins/authority_level";
import UserForm from "./UserForm";

export default {
  name: "user-management",
  mixins: [form_container, authority_level],
  components: { UserForm },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      form_data: undefined,
      search_field: ["name", "branch_name", "user_group_name", "desc"],
      placeholder: "이름, 부서, 그룹, 비고",
    };
  },
  computed: {
    ...mapGetters(["table_user", "table_user_group", "table_branch"]),
    items() {
      let items = Object.assign([], this.table_user);
      items.forEach(item => {
        let result = this.table_user_group.find(
          i => i.id == item.user_group_id
        );
        if (result) {
          item.user_group_name = result.name
        }
        result = this.table_branch.find(
          i => i.id == item.branch_id
        );
        if (result) {
          item.branch_name = result.name
        }        
      });
      return items;
    },
    has_grant_write() {      
      return this.isWriteLevel('user');
    },
  },
  methods: {
    /**Click on the row to open the dialog box */
    handleClickRow(data) {
      this.openDialog(data);
    },
    /**Open dialog boxes */
    openDialog(data) {
      let clone = data ? Object.assign({}, data) : undefined;
      this.form_data = clone;
      this.dialogVisible = true;
    },
    /**Close dialog boxes */
    closeDialog() {
      this.dialogVisible = false;
    },
    /** Click the Add button to open the dialog box*/
    handleClickedCreate() {
      this.openDialog();
    },
    /**Data numbering */
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleCompleted(message) {
      this.closeDialog();
      this.form_data = undefined;
      if (!message) {
        return;
      }
      this.$notify(message);
    },
  }
};
</script>
